import type { ModuleDeclaration } from "didi";
import WardleyLabelEditing from "./WardleyLabelEditing.js";

/** Custom inline label editing (HTML overlay). */
export const labelEditingModule: ModuleDeclaration = {
  __init__: ["wardleyLabelEditing"],
  wardleyLabelEditing: ["type", WardleyLabelEditing],
};

export { default as WardleyLabelEditing } from "./WardleyLabelEditing.js";
export { createFieldError, FIELD_TO_CAPTION_GAP, type FieldError } from "./fieldError.js";
export { focusField, type FieldSelection } from "./WardleyLabelEditing.js";
export { isImeCompositionKey } from "./imeComposition.js";
